import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import TextMessageForm from '../../components/TextMessages/TextMessageForm';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['textMessage']}`;

const TextMessagesDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  const [textMessage, setTextMessage] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [deleteError, setDeleteError] = useState();
  const [guidanceShow, setGuidanceShow] = useState(false);
  const [useInAutomation, setUseInAutomation] = useState(false);

  const { accountId, domainId, textMessageId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/textMessages/${textMessageId}`)
      .then(({ textMessage }) => {
        if (!textMessage) {
          navigate(`/accounts/${accountId}/domains/${domainId}/textMessages`);
        }

        setTextMessage(textMessage);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, textMessageId]);

  const update = (textMessage) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/textMessages/${textMessageId}`, {
      method: 'PUT',
      body: JSON.stringify(textMessage),
    })
      .then((redirect) => {
        setGuidanceShow(false);
        redirect && navigate(`/accounts/${accountId}/domains/${domainId}/textMessages`);
      })
      .catch(setUserError);
  };

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/textMessages/${textMessage.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(location.pathname.replace(`/textMessages/${textMessage.id}/details`, '/textMessages'));
      })
      .catch(setDeleteError);
  };

  const showUserFlow = () => {
    setGuidanceShow(true);
    setUseInAutomation(true);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!textMessage) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/textMessages` },
    { title: textMessage.name, href: `#${location.pathname.replace('/details', '/analytics')}` },
    { title: 'Edit' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${textMessage.name} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="SMS / Text Message"
        redirect={`/accounts/${accountId}/domains/${domainId}/textMessages`}
        show={guidanceShow}
        elementTypes={['workflows']}
        element={textMessage}
        setShow={() => {
          setGuidanceShow(false);
          setUseInAutomation(false);
        }}
        useInAutomation={useInAutomation}
      />
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <TextMessageForm
              textMessage={textMessage}
              saveTextMessage={(textMessage) => {
                update(textMessage);
              }}
              deleteTextMessage={(cb) => del(cb)}
              showUserFlow={() => showUserFlow(true)}
              deleteError={deleteError?.message}
              onBack={() => navigate(-1)}
            />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default TextMessagesDetailsPage;
